const menuJson = {
  evidenceList: [
    {
      name: 'AI数据分析',
      hasChildList: false,
      href: '/evidenceCenter/dataAnalytics',
      menuLogo: 'icon-management-01'
    },
    {
      name: 'AI执行情报分析',
      hasChildList: false,
      href: '/evidenceCenter/intelligenceAnalysis',
      menuLogo: 'icon-management-01'
    },
    {
      name: 'AI溯源情报分析',
      hasChildList: false,
      href: '/evidenceCenter/partiesDataAnalytics',
      menuLogo: 'icon-project-02'
    }

  ],
  // 情报
  informationList: [
    {
      name: '数据分析',
      hasChildList: false,
      href: '/informationCenter/dataAnalytics',
      menuLogo: 'icon-management-01'
    },
    {
      name: '执行情报分析',
      hasChildList: false,
      href: '/informationCenter/intelligenceAnalysis',
      menuLogo: 'icon-management-01'
    },
    {
      name: '溯源情报分析',
      hasChildList: false,
      href: '/informationCenter/partiesDataAnalytics',
      menuLogo: 'icon-project-02'
    },
    {
      name: '案例检索',
      hasChildList: true,
      matchName: '案例检索',
      href: '',
      menuLogo: 'icon-clue-01',
      childList: [
        {
          name: '行政',
          hasChildList: false,
          href: '/informationCenter/administrative',
          menuLogo: ''
        },

        {
          name: '海关',
          hasChildList: false,
          href: '/informationCenter/customs',
          menuLogo: ''
        },
        {
          name: '民事',
          hasChildList: false,
          href: '/informationCenter/civil',
          menuLogo: ''
        },
        {
          name: '刑事',
          hasChildList: false,
          href: '/informationCenter/criminal',
          menuLogo: ''
        }
      ]
    },
    {
      name: '专利检索',
      hasChildList: false,
      href: '/informationCenter/patentEvaluation',
      menuLogo: 'icon-management-01'

    },
    {
      name: '维权检索',
      hasChildList: false,
      href: '/informationCenter/rightsProtectionReport',
      menuLogo: 'icon-project-02'
    }

  ],
  knowledgeGraph: [
    {
      name: '知识图谱',
      hasChildList: false,
      href: '/knowledgeGraph',
      menuLogo: 'icon-management-01'
    }
  ],
  relationalGraph: [
    {
      name: '关系图谱',
      hasChildList: false,
      href: '/relationalGraph',
      menuLogo: 'icon-management-01'
    }
  ],
  infringementMap: [
    {
      name: '侵权地图',
      hasChildList: false,
      href: '/infringementMap',
      menuLogo: 'icon-management-01'
    }
  ],
  systemCenter: [
    {
      name: '用户管理',
      hasChildList: false,
      href: '/systemCenter/userAdmin',
      menuLogo: 'icon-management-01'
    }
  ],
  tortMap: [
    {
      name: '侵权地图',
      hasChildList: false,
      href: '/tortMap',
      menuLogo: 'icon-management-01'
    }
  ],
  partiesDataAnalytics: [
    {
      name: '当事人数据分析',
      hasChildList: false,
      href: '/partiesDataAnalytics',
      menuLogo: 'icon-management-01'
    }
  ]
}

export default {
  menuJson
}



// WEBPACK FOOTER //
// ./src/libs/menu.js